import React from 'react'

/**
  * @class Basics
  * Show basics
*/
class BasicsList extends React.Component {
  render() {
    return <section className="foundations bg--black">
      <div className="row">
        <div className="col-lg-12 center-text">
          <h2>Nos piliers</h2>
        </div>
        <div className="col-lg-3 center-text foundations__resume">
          <h3>Le retail&nbsp;:<br/>notre ADN</h3>
          <div className="basics__img"><img src={ process.env.PUBLIC_URL + "/images/pic-strategie.png" } alt="" /></div>
          <p>Notre métier. <br/>Notre vocation.</p>
        </div>
        <div className="col-lg-3 center-text foundations__resume">
          <h3>L’innovation technologique&nbsp;:<br/>notre culture</h3>
          <div className="basics__img"><img src={ process.env.PUBLIC_URL + "/images/pic-conception.png" } alt="" /></div>
          <p>Anticiper. Innover. <br/>Devancer.</p>
        </div>

        <div className="col-lg-3 center-text foundations__resume">
          <h3>La créativité&nbsp;:<br/>notre credo</h3>
          <div className="basics__img"><img src={ process.env.PUBLIC_URL + "/images/pic-conseil.png" } alt="" /></div>
          <p>Inventer. <br/>Se réinventer.</p>
        </div>
        <div className="col-lg-3 center-text foundations__resume">
          <h3>Le ROI : <br/>notre pragmatisme</h3>
          <div className="basics__img"><img src={ process.env.PUBLIC_URL + "/images/pic-innovation.png" } alt="" /></div>
          <p>Une belle idée n’est rien <br/>sans résultat concret.</p>

        </div>
        <div className="col-lg-12 center-text">
          <a href={ process.env.PUBLIC_URL + "/agence "} className="button">En savoir plus</a>
        </div>
      </div>
    </section>
  }
}
/*
  TODO:
  If we keep this like that, replace that by an object
*/

export default BasicsList




// WEBPACK FOOTER //
// ./src/components/Basics/BasicsList.jsx